<template>
  <div>
    <div style="padding: 20px; margin-bottom: 30px;">
      <el-row style="padding-top: 10px; margin-bottom: 20px;">
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <el-card class="box-card">
            <div>{{ generateCustomizeString('digitalWallet') }}</div>
            <div style="padding-top: 10px; font-size: 26px; font-weight: bold;">$ {{ balance }} NZD</div>
            <el-row>
              <el-col :span="24">
                <div style="padding-top: 15px;">{{ generateCustomizeString('withdrawableBalance') }}: ${{ can_withdrawal_balance }}</div>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <p>
        <b>{{ generateCustomizeString('walletTransaction') }}</b>
      </p>
      <el-table
        :data="walletData"
        v-loading="listLoading"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
        style="margin-bottom: 20px;"
      >
        <el-table-column :label="generateCustomizeString('date')" prop="created_at"></el-table-column>
        <el-table-column :label="generateCustomizeString('type')" prop="source_name"></el-table-column>
        <el-table-column :label="generateCustomizeString('transactionNo')" prop="transaction_no">
          <template slot-scope="scope">
            <div v-if="scope.row.source_name === '订单' && scope.row.order" @click="viewOrder(scope.row.order)" style="color: #409EFF;">{{scope.row.order.out_trade_no}}</div>
            <div v-else>{{scope.row.transaction_no}}</div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operationNotes')" prop="message"></el-table-column>
        <el-table-column :label="generateCustomizeString('amount')" prop="amount">
          <template slot-scope="scope">
            <div>NZD ${{ scope.row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('balance')" prop="balance">
          <template slot-scope="scope">
            <div>NZD ${{ scope.row.balance }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="generateCustomizeString('view')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="clickView(scope.$index)">{{ generateCustomizeString('view') }}</el-button>
          </template>
        </el-table-column>-->
      </el-table>
    </div>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfList"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'DigitalWallet',
  data() {
    return {
      currentPage: 1,
      currentTotal: 0,
      numOfList: 15,
      balance: 0,
      can_withdrawal_balance: 0,
      listLoading: true,
      viewDetailsDialogVisible: false,
      walletData: [],
      currency: '1',
      total: 0,
      options: [
        {
          value: '选项1',
          label: this.generateCustomizeString('unpaidOrders')
        },
        {
          value: '选项2',
          label: this.generateCustomizeString('alreadyPaid')
        },
        {
          value: '选项3',
          label: this.generateCustomizeString('shippedOrders')
        },
        {
          value: '选项4',
          label: this.generateCustomizeString('completed')
        },
        {
          value: '选项5',
          label: this.generateCustomizeString('closedOrders')
        }
      ]
    }
  },
  created() {
    this.fetchData()
    this.fetchWalletTransactions(this.currentPage)
  },
  methods: {
    generateCustomizeString,
    formatAmount(value) {
      return parseFloat(value / 100).toFixed(2)
    },
    clickView(index) {
      this.viewDetailsDialogVisible = true
      // this.uploadForm.username = this.walletData[index].username
    },
    viewOrder(order) {
      this.$router.push({
        name: 'OrderView',
        params: { orderId: order.id }
      })
    },
    fetchData() {
      const that = this
      return new Promise(function(resolve, reject) {
        that.listLoading = true
        request({
          url: 'agent/wallet',
          method: 'get',
          params: {
            shop_id: that.$route.params.agentId
          }
        }).then(res => {
          console.log(res)
          if (res.status === 0) {
            that.balance = parseFloat(res.data.balance / 100).toFixed(2)
            that.can_withdrawal_balance = parseFloat(
              res.data.can_withdrawal_balance / 100
            ).toFixed(2)
            resolve()
          }
        }).finally(() => {
          that.listLoading = false
        })
      })
    },
    fetchWalletTransactions(page) {
      const that = this
      return new Promise(function(resolve, reject) {
        that.listLoading = true
        request({
          url: 'agent/wallet/transactions',
          method: 'get',
          params: {
            shop_id: that.$route.params.agentId,
            page: page,
            page_size: that.numOfList
          }
        }).then(res => {
          const meta = res.meta
          if (res.status === 0) {
            for (let i = 0; i < res.data.length; i++) {
              var obj = res.data[i]
              obj.amount = that.formatAmount(obj.amount)
              obj.balance = that.formatAmount(obj.balance)
              that.walletData.push(res.data[i])
            }
            that.currentPage = meta.current_page
            that.currentTotal = meta.total
            console.log(res.data)
          }
        }).finally(() => {
          that.listLoading = false
        })
      })
    },
    handleCurrentChange(val) {
      this.fetchWalletTransactions(val)
    }
  }
}
</script>

<style type="text/css">
.el-upload-dragger {
  width: 230px;
  height: 150px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}
.grid-content {
  min-height: 30px;
  margin: 0 auto;
  flex: auto;
  overflow: auto;
  -webkit-align-items: center;
  align-items: center;
}
.title-label {
  display: inline-block;
  text-align: left;
  // width: 80px;
}
.content-label {
  padding: 0px 0px 0px 10px;
}
.upload-tip {
  font-size: 12px;
  line-height: 20px;
}
.img-example {
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
